/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { receiptControllerCreate } from '../fn/receipt/receipt-controller-create';
import { ReceiptControllerCreate$Params } from '../fn/receipt/receipt-controller-create';
import { receiptControllerCreateNoScheduleReceipt } from '../fn/receipt/receipt-controller-create-no-schedule-receipt';
import { ReceiptControllerCreateNoScheduleReceipt$Params } from '../fn/receipt/receipt-controller-create-no-schedule-receipt';
import { receiptControllerDelete } from '../fn/receipt/receipt-controller-delete';
import { ReceiptControllerDelete$Params } from '../fn/receipt/receipt-controller-delete';
import { receiptControllerDeleteNoScheduleReceipt } from '../fn/receipt/receipt-controller-delete-no-schedule-receipt';
import { ReceiptControllerDeleteNoScheduleReceipt$Params } from '../fn/receipt/receipt-controller-delete-no-schedule-receipt';
import { receiptControllerFindByEnrollmentScheduleId } from '../fn/receipt/receipt-controller-find-by-enrollment-schedule-id';
import { ReceiptControllerFindByEnrollmentScheduleId$Params } from '../fn/receipt/receipt-controller-find-by-enrollment-schedule-id';
import { receiptControllerFindById } from '../fn/receipt/receipt-controller-find-by-id';
import { ReceiptControllerFindById$Params } from '../fn/receipt/receipt-controller-find-by-id';
import { receiptControllerFindByTicketId } from '../fn/receipt/receipt-controller-find-by-ticket-id';
import { ReceiptControllerFindByTicketId$Params } from '../fn/receipt/receipt-controller-find-by-ticket-id';
import { receiptControllerFindFilter } from '../fn/receipt/receipt-controller-find-filter';
import { ReceiptControllerFindFilter$Params } from '../fn/receipt/receipt-controller-find-filter';
import { receiptControllerFindRefundById } from '../fn/receipt/receipt-controller-find-refund-by-id';
import { ReceiptControllerFindRefundById$Params } from '../fn/receipt/receipt-controller-find-refund-by-id';
import { receiptControllerRefund } from '../fn/receipt/receipt-controller-refund';
import { ReceiptControllerRefund$Params } from '../fn/receipt/receipt-controller-refund';
import { receiptControllerRefundByTicket } from '../fn/receipt/receipt-controller-refund-by-ticket';
import { ReceiptControllerRefundByTicket$Params } from '../fn/receipt/receipt-controller-refund-by-ticket';
import { receiptControllerRefundNoReceipt } from '../fn/receipt/receipt-controller-refund-no-receipt';
import { ReceiptControllerRefundNoReceipt$Params } from '../fn/receipt/receipt-controller-refund-no-receipt';
import { receiptControllerRefundNoScheduleReceipt } from '../fn/receipt/receipt-controller-refund-no-schedule-receipt';
import { ReceiptControllerRefundNoScheduleReceipt$Params } from '../fn/receipt/receipt-controller-refund-no-schedule-receipt';
import { receiptControllerSearch } from '../fn/receipt/receipt-controller-search';
import { ReceiptControllerSearch$Params } from '../fn/receipt/receipt-controller-search';
import { receiptControllerSearchCenterChildWithReceiptsDetail } from '../fn/receipt/receipt-controller-search-center-child-with-receipts-detail';
import { ReceiptControllerSearchCenterChildWithReceiptsDetail$Params } from '../fn/receipt/receipt-controller-search-center-child-with-receipts-detail';
import { receiptControllerSearchCenterChildWithReceiptsSummary } from '../fn/receipt/receipt-controller-search-center-child-with-receipts-summary';
import { ReceiptControllerSearchCenterChildWithReceiptsSummary$Params } from '../fn/receipt/receipt-controller-search-center-child-with-receipts-summary';
import { receiptControllerSearchCurrentMonthData } from '../fn/receipt/receipt-controller-search-current-month-data';
import { ReceiptControllerSearchCurrentMonthData$Params } from '../fn/receipt/receipt-controller-search-current-month-data';
import { receiptControllerSearchTotal } from '../fn/receipt/receipt-controller-search-total';
import { ReceiptControllerSearchTotal$Params } from '../fn/receipt/receipt-controller-search-total';
import { receiptControllerSearchTotalNoReceipt } from '../fn/receipt/receipt-controller-search-total-no-receipt';
import { ReceiptControllerSearchTotalNoReceipt$Params } from '../fn/receipt/receipt-controller-search-total-no-receipt';
import { receiptControllerUpdate } from '../fn/receipt/receipt-controller-update';
import { ReceiptControllerUpdate$Params } from '../fn/receipt/receipt-controller-update';
import { receiptControllerUpdateNoScheduleReceipt } from '../fn/receipt/receipt-controller-update-no-schedule-receipt';
import { ReceiptControllerUpdateNoScheduleReceipt$Params } from '../fn/receipt/receipt-controller-update-no-schedule-receipt';
import { receiptControllerUpdateNoScheduleRefund } from '../fn/receipt/receipt-controller-update-no-schedule-refund';
import { ReceiptControllerUpdateNoScheduleRefund$Params } from '../fn/receipt/receipt-controller-update-no-schedule-refund';
import { receiptControllerUpdateRefund } from '../fn/receipt/receipt-controller-update-refund';
import { ReceiptControllerUpdateRefund$Params } from '../fn/receipt/receipt-controller-update-refund';
import { ReceiptDto } from '../models/receipt-dto';
import { ReceiptFilterDto } from '../models/receipt-filter-dto';
import { RefundReceiptDto } from '../models/refund-receipt-dto';

@Injectable({ providedIn: 'root' })
export class ReceiptService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `receiptControllerSearch()` */
  static readonly ReceiptControllerSearchPath = '/api/receipt/search';

  /**
   * 수납 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearch$Response(params: ReceiptControllerSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return receiptControllerSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * 수납 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearch(params: ReceiptControllerSearch$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.receiptControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerSearchTotal()` */
  static readonly ReceiptControllerSearchTotalPath = '/api/receipt/search/total';

  /**
   * 총 수납내역 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerSearchTotal()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearchTotal$Response(params: ReceiptControllerSearchTotal$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return receiptControllerSearchTotal(this.http, this.rootUrl, params, context);
  }

  /**
   * 총 수납내역 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerSearchTotal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearchTotal(params: ReceiptControllerSearchTotal$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.receiptControllerSearchTotal$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerSearchTotalNoReceipt()` */
  static readonly ReceiptControllerSearchTotalNoReceiptPath = '/api/receipt/search/total/no-receipt';

  /**
   * 회기 외 수납내역 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerSearchTotalNoReceipt()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearchTotalNoReceipt$Response(params: ReceiptControllerSearchTotalNoReceipt$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return receiptControllerSearchTotalNoReceipt(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기 외 수납내역 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerSearchTotalNoReceipt$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearchTotalNoReceipt(params: ReceiptControllerSearchTotalNoReceipt$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.receiptControllerSearchTotalNoReceipt$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerSearchCenterChildWithReceiptsDetail()` */
  static readonly ReceiptControllerSearchCenterChildWithReceiptsDetailPath = '/api/receipt/center-child/detail';

  /**
   * 센터에 소속된 아동 수납 내역 조회 (금월 상세 내역).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerSearchCenterChildWithReceiptsDetail()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearchCenterChildWithReceiptsDetail$Response(params: ReceiptControllerSearchCenterChildWithReceiptsDetail$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return receiptControllerSearchCenterChildWithReceiptsDetail(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터에 소속된 아동 수납 내역 조회 (금월 상세 내역).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerSearchCenterChildWithReceiptsDetail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearchCenterChildWithReceiptsDetail(params: ReceiptControllerSearchCenterChildWithReceiptsDetail$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.receiptControllerSearchCenterChildWithReceiptsDetail$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerSearchCenterChildWithReceiptsSummary()` */
  static readonly ReceiptControllerSearchCenterChildWithReceiptsSummaryPath = '/api/receipt/center-child/summary';

  /**
   * 센터에 소속된 아동 수납 내역 조회 (월별 요약).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerSearchCenterChildWithReceiptsSummary()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearchCenterChildWithReceiptsSummary$Response(params: ReceiptControllerSearchCenterChildWithReceiptsSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return receiptControllerSearchCenterChildWithReceiptsSummary(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터에 소속된 아동 수납 내역 조회 (월별 요약).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerSearchCenterChildWithReceiptsSummary$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearchCenterChildWithReceiptsSummary(params: ReceiptControllerSearchCenterChildWithReceiptsSummary$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.receiptControllerSearchCenterChildWithReceiptsSummary$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerSearchCurrentMonthData()` */
  static readonly ReceiptControllerSearchCurrentMonthDataPath = '/api/receipt/center-child/current-month';

  /**
   * 센터에 소속된 아동 수납 내역 조회 (월별 내역).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerSearchCurrentMonthData()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearchCurrentMonthData$Response(params: ReceiptControllerSearchCurrentMonthData$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return receiptControllerSearchCurrentMonthData(this.http, this.rootUrl, params, context);
  }

  /**
   * 센터에 소속된 아동 수납 내역 조회 (월별 내역).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerSearchCurrentMonthData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerSearchCurrentMonthData(params: ReceiptControllerSearchCurrentMonthData$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.receiptControllerSearchCurrentMonthData$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerFindFilter()` */
  static readonly ReceiptControllerFindFilterPath = '/api/receipt/filter';

  /**
   * 수납 필터 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerFindFilter()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerFindFilter$Response(params: ReceiptControllerFindFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptFilterDto>> {
    return receiptControllerFindFilter(this.http, this.rootUrl, params, context);
  }

  /**
   * 수납 필터 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerFindFilter$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerFindFilter(params: ReceiptControllerFindFilter$Params, context?: HttpContext): Observable<ReceiptFilterDto> {
    return this.receiptControllerFindFilter$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptFilterDto>): ReceiptFilterDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerFindByTicketId()` */
  static readonly ReceiptControllerFindByTicketIdPath = '/api/receipt/ticket';

  /**
   * 서비스 ID로 수납 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerFindByTicketId()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerFindByTicketId$Response(params: ReceiptControllerFindByTicketId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReceiptDto>>> {
    return receiptControllerFindByTicketId(this.http, this.rootUrl, params, context);
  }

  /**
   * 서비스 ID로 수납 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerFindByTicketId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerFindByTicketId(params: ReceiptControllerFindByTicketId$Params, context?: HttpContext): Observable<Array<ReceiptDto>> {
    return this.receiptControllerFindByTicketId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ReceiptDto>>): Array<ReceiptDto> => r.body)
    );
  }

  /** Path part for operation `receiptControllerFindByEnrollmentScheduleId()` */
  static readonly ReceiptControllerFindByEnrollmentScheduleIdPath = '/api/receipt/enrollment-schedule';

  /**
   * 치료일정 수납 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerFindByEnrollmentScheduleId()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerFindByEnrollmentScheduleId$Response(params: ReceiptControllerFindByEnrollmentScheduleId$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerFindByEnrollmentScheduleId(this.http, this.rootUrl, params, context);
  }

  /**
   * 치료일정 수납 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerFindByEnrollmentScheduleId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerFindByEnrollmentScheduleId(params: ReceiptControllerFindByEnrollmentScheduleId$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerFindByEnrollmentScheduleId$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerFindRefundById()` */
  static readonly ReceiptControllerFindRefundByIdPath = '/api/receipt/refund';

  /**
   * 수납 환불 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerFindRefundById()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerFindRefundById$Response(params: ReceiptControllerFindRefundById$Params, context?: HttpContext): Observable<StrictHttpResponse<RefundReceiptDto>> {
    return receiptControllerFindRefundById(this.http, this.rootUrl, params, context);
  }

  /**
   * 수납 환불 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerFindRefundById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerFindRefundById(params: ReceiptControllerFindRefundById$Params, context?: HttpContext): Observable<RefundReceiptDto> {
    return this.receiptControllerFindRefundById$Response(params, context).pipe(
      map((r: StrictHttpResponse<RefundReceiptDto>): RefundReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerRefund()` */
  static readonly ReceiptControllerRefundPath = '/api/receipt/refund';

  /**
   * 수납 환불.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerRefund()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerRefund$Response(params: ReceiptControllerRefund$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerRefund(this.http, this.rootUrl, params, context);
  }

  /**
   * 수납 환불.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerRefund$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerRefund(params: ReceiptControllerRefund$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerRefund$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerUpdateRefund()` */
  static readonly ReceiptControllerUpdateRefundPath = '/api/receipt/refund';

  /**
   * 수납 환불 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerUpdateRefund()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerUpdateRefund$Response(params: ReceiptControllerUpdateRefund$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerUpdateRefund(this.http, this.rootUrl, params, context);
  }

  /**
   * 수납 환불 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerUpdateRefund$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerUpdateRefund(params: ReceiptControllerUpdateRefund$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerUpdateRefund$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerFindById()` */
  static readonly ReceiptControllerFindByIdPath = '/api/receipt/{id}';

  /**
   * 수납 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerFindById$Response(params: ReceiptControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 수납 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerFindById(params: ReceiptControllerFindById$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerDelete()` */
  static readonly ReceiptControllerDeletePath = '/api/receipt/{id}';

  /**
   * 수납 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerDelete$Response(params: ReceiptControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 수납 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerDelete(params: ReceiptControllerDelete$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerUpdate()` */
  static readonly ReceiptControllerUpdatePath = '/api/receipt/{id}';

  /**
   * 수납 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerUpdate$Response(params: ReceiptControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 수납 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerUpdate(params: ReceiptControllerUpdate$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerCreate()` */
  static readonly ReceiptControllerCreatePath = '/api/receipt';

  /**
   * 수납 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerCreate$Response(params: ReceiptControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 수납 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerCreate(params: ReceiptControllerCreate$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerCreateNoScheduleReceipt()` */
  static readonly ReceiptControllerCreateNoScheduleReceiptPath = '/api/receipt/normal';

  /**
   * 회기 외 수납 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerCreateNoScheduleReceipt()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerCreateNoScheduleReceipt$Response(params: ReceiptControllerCreateNoScheduleReceipt$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerCreateNoScheduleReceipt(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기 외 수납 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerCreateNoScheduleReceipt$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerCreateNoScheduleReceipt(params: ReceiptControllerCreateNoScheduleReceipt$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerCreateNoScheduleReceipt$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerRefundNoScheduleReceipt()` */
  static readonly ReceiptControllerRefundNoScheduleReceiptPath = '/api/receipt/refund/normal';

  /**
   * 회기 외 수납 환불.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerRefundNoScheduleReceipt()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerRefundNoScheduleReceipt$Response(params: ReceiptControllerRefundNoScheduleReceipt$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerRefundNoScheduleReceipt(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기 외 수납 환불.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerRefundNoScheduleReceipt$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerRefundNoScheduleReceipt(params: ReceiptControllerRefundNoScheduleReceipt$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerRefundNoScheduleReceipt$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerUpdateNoScheduleRefund()` */
  static readonly ReceiptControllerUpdateNoScheduleRefundPath = '/api/receipt/refund/normal';

  /**
   * 회기 외 수납 환불 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerUpdateNoScheduleRefund()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerUpdateNoScheduleRefund$Response(params: ReceiptControllerUpdateNoScheduleRefund$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerUpdateNoScheduleRefund(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기 외 수납 환불 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerUpdateNoScheduleRefund$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerUpdateNoScheduleRefund(params: ReceiptControllerUpdateNoScheduleRefund$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerUpdateNoScheduleRefund$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerRefundNoReceipt()` */
  static readonly ReceiptControllerRefundNoReceiptPath = '/api/receipt/refund/no-receipt';

  /**
   * 회기 외 수납 환불.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerRefundNoReceipt()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerRefundNoReceipt$Response(params: ReceiptControllerRefundNoReceipt$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerRefundNoReceipt(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기 외 수납 환불.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerRefundNoReceipt$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerRefundNoReceipt(params: ReceiptControllerRefundNoReceipt$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerRefundNoReceipt$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerRefundByTicket()` */
  static readonly ReceiptControllerRefundByTicketPath = '/api/receipt/refund/ticket';

  /**
   * 티켓 단위 환불 (특정 회기와 연결되지 않음).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerRefundByTicket()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerRefundByTicket$Response(params: ReceiptControllerRefundByTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return receiptControllerRefundByTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * 티켓 단위 환불 (특정 회기와 연결되지 않음).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerRefundByTicket$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerRefundByTicket(params: ReceiptControllerRefundByTicket$Params, context?: HttpContext): Observable<boolean> {
    return this.receiptControllerRefundByTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `receiptControllerDeleteNoScheduleReceipt()` */
  static readonly ReceiptControllerDeleteNoScheduleReceiptPath = '/api/receipt/normal/{id}';

  /**
   * 회기 외 수납 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerDeleteNoScheduleReceipt()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerDeleteNoScheduleReceipt$Response(params: ReceiptControllerDeleteNoScheduleReceipt$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerDeleteNoScheduleReceipt(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기 외 수납 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerDeleteNoScheduleReceipt$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  receiptControllerDeleteNoScheduleReceipt(params: ReceiptControllerDeleteNoScheduleReceipt$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerDeleteNoScheduleReceipt$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

  /** Path part for operation `receiptControllerUpdateNoScheduleReceipt()` */
  static readonly ReceiptControllerUpdateNoScheduleReceiptPath = '/api/receipt/normal/{id}';

  /**
   * 회기 외 수납 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `receiptControllerUpdateNoScheduleReceipt()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerUpdateNoScheduleReceipt$Response(params: ReceiptControllerUpdateNoScheduleReceipt$Params, context?: HttpContext): Observable<StrictHttpResponse<ReceiptDto>> {
    return receiptControllerUpdateNoScheduleReceipt(this.http, this.rootUrl, params, context);
  }

  /**
   * 회기 외 수납 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `receiptControllerUpdateNoScheduleReceipt$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  receiptControllerUpdateNoScheduleReceipt(params: ReceiptControllerUpdateNoScheduleReceipt$Params, context?: HttpContext): Observable<ReceiptDto> {
    return this.receiptControllerUpdateNoScheduleReceipt$Response(params, context).pipe(
      map((r: StrictHttpResponse<ReceiptDto>): ReceiptDto => r.body)
    );
  }

}
